const types = {
  LOADING_DATA: 'LOADING_DATA',
  SET_BK_THEME: 'SET_BK_THEME',
  SET_PLK_THEME: 'SET_PLK_THEME',
  SET_TH_THEME: 'SET_TH_THEME',
};
export default types;
